import {FC} from "react";
import {Modal} from "react-bootstrap";
import BackButton from "./BackButton";

type Props = {
  title?: string;
  onHide: () => void;
}

const ModalHeader: FC<Props> = (props) => {
  const {title, onHide} = props;
  return (
    <Modal.Header className="header-modal spaces h-40px">
      <div className="d-flex align-items-center">
        <BackButton onClick={onHide}/>
        <div className="title spaces ml-20">
          {title}
        </div>
      </div>
    </Modal.Header>
  )
};

export default ModalHeader
